import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { Item } from '@/types/item';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';
import { transformDateStringFrance } from '@/utilities/datetime';
import { useItemMmaos } from '@/hooks/item';
import { formatCurrency } from '@/utilities/currency';
import useTable from '@/hooks/table';

const defaultPageSize = 20;
const View: React.FC<{ item: Item }> = ({ item }) => {
  const { t } = useTranslation();

  const { page, pageSize, totalItems, onPageChange, persistTotalItems } = useTable(defaultPageSize);

  const [open, setOpen] = useState(false);

  const { data: mmaos, isFetching } = useItemMmaos(item.productId, page, pageSize, open);

  useEffect(() => {
    if (mmaos) persistTotalItems(mmaos.total);
  }, [mmaos]);

  const columns: GridColDef[] = [
    { field: 'id', headerName: t('item.mmao.nego_ref') },
    { field: 'buyerEmail', headerName: t('item.mmao.buyer_email') },
    { field: 'status', headerName: t('item.mmao.status') },
    { field: 'buyerOfferPrice', headerName: t('item.mmao.buyerOfferPrice') },
    { field: 'sellerPrice', headerName: t('item.mmao.sellerPrice') },
    { field: 'sellerReceiveAmount', headerName: t('item.mmao.sellerReceiveAmount') },
    {
      field: 'offeredDate',
      headerName: t('item.mmao.offered_date'),
      valueGetter: (params: GridValueGetterParams) => (params.value ? transformDateStringFrance(params.value) : '-'),
    },
    {
      field: 'closedDate',
      headerName: t('item.mmao.closed_date'),
      valueGetter: (params: GridValueGetterParams) => (params.value ? transformDateStringFrance(params.value) : '-'),
    },
  ];

  const rows = mmaos
    ? mmaos.data.map((item) => {
        return {
          ...item,
          buyerOfferPrice: item.buyerFormattedOfferPrice || '-',
          sellerPrice: item.sellerFormattedOfferPrice || '-',
          sellerReceiveAmount: item.sellerFormattedEarningAmount || '-',
        };
      })
    : [];

  return (
    <Container
      title={t('item.mmao.title')}
      actions={[]}
      handler={{ open, setOpen }}
      testId="item_mmao"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={isFetching}
        table={{
          kind: 'DynamicTable',
          totalItem: totalItems,
          pageSize: pageSize,
          pageSizeOptions: [defaultPageSize, 50, 100],
          onPageChange: onPageChange,
        }}
      />
    </Container>
  );
};

export default View;
